import { serverDate } from "./date"

export const setDataStorage = (FILTER_NAME, FILTER_VALUE) => {
   localStorage.setItem(FILTER_NAME, JSON.stringify(FILTER_VALUE))
}

export const getDataStorage = (FILTER_NAME) => {
   return JSON.parse(localStorage.getItem(FILTER_NAME))
}

export const getDateFormatStorage = (FILTER_NAME) => {
   const date = getDataStorage(FILTER_NAME);

   return date != null ? serverDate(date) : null;
}

export const removeDataStorage = (FILTER_NAME) => {
  return localStorage.removeItem(FILTER_NAME);
}


export const filterInputValue = (FILTER_NAME) => {
   const checkBranch = getDataStorage(FILTER_NAME)

   if (checkBranch?.length && checkBranch?.length !== null) {
      return getDataStorage(FILTER_NAME)
   }

   return []
}
